// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.show-search-conditions-pop .show-search-conditions-tags {
  display: -webkit-inline-flex;
  display: inline-flex;
  overflow: hidden;
  max-width: 320px;
  min-width: 40px;
  text-align: left;
  word-break: break-all;
  margin: 4px 4px;
  color: #666;
  border-color: #DBE0E5;
  background-color: transparent;
  border-radius: 3px;
}
.show-search-conditions-pop .show-search-conditions-tags .wui-tag-text {
  -webkit-flex-shrink: 1;
          flex-shrink: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.show-search-conditions-pop .show-search-conditions-tags .uf-close {
  color: #ADB4BC;
}
.ref-view {
  height: 100%;
}
.footer-button {
  position: relative;
  height: 60px;
  bottom: 0;
  width: 100%;
  padding: 20px 0;
  border-top: solid 1px #ddd;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
          align-items: center;
  -webkit-justify-content: space-around;
          justify-content: space-around;
}
.footer-button .confirm {
  padding: 10px 0;
  text-align: center;
  width: 40%;
  background-color: #E14C46;
  color: #fff;
  border-radius: 8px;
}
.footer-button .cancel {
  padding: 10px 0;
  text-align: center;
  width: 40%;
  border: solid 1px #ddd;
  border-radius: 8px;
}
.adm-popup-body {
  background-color: #fff;
}
.popup-list-loading {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: center;
          justify-content: center;
  -webkit-align-items: center;
          align-items: center;
  width: 100%;
  background: transparent;
  position: fixed;
  top: 45px;
  bottom: 84px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/style/index.less","webpack://./src/components/CommonPicker/style/index.less"],"names":[],"mappings":"AAOA;EAEI,4BAAA;EAAA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;EACA,6BAAA;EACA,kBAAA;ACPJ;ADLA;EAeM,sBAAA;UAAA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;ACPN;ADXA;EAsBM,cAAA;ACRN;AAnBA;EACI,YAAA;AAqBJ;AAlBA;EACI,kBAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,0BAAA;EACA,qBAAA;EAAA,aAAA;EACA,2BAAA;UAAA,mBAAA;EACA,qCAAA;UAAA,6BAAA;AAoBJ;AA7BA;EAYQ,eAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;AAoBR;AArCA;EAqBQ,eAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,kBAAA;AAmBR;AAbA;EACI,sBAAA;AAeJ;AAZA;EACI,qBAAA;EAAA,aAAA;EACA,+BAAA;UAAA,uBAAA;EACA,2BAAA;UAAA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;AAcJ","sourcesContent":["// 样式变量定义\n// @theme: #f53c32;\n\n// 公共样式\n// body{\n//     background-color: #ffffff;\n// }\n.show-search-conditions-pop {\n  .show-search-conditions-tags {\n    display: inline-flex;\n    overflow: hidden;\n    max-width: 320px;\n    min-width: 40px;\n    text-align: left;\n    word-break: break-all;\n    margin: 4px 4px;\n    color: #666;\n    border-color: #DBE0E5;\n    background-color: transparent;\n    border-radius: 3px;\n\n    .wui-tag-text {\n      flex-shrink: 1;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n    }\n\n    .uf-close {\n      color: #ADB4BC;\n    }\n  }\n}","@import '../../../assets/style/index.less';\n\n.ref-view {\n    height: 100%;\n}\n\n.footer-button {\n    position: relative;\n    height: 60px;\n    bottom: 0;\n    width: 100%;\n    padding: 20px 0;\n    border-top: solid 1px #ddd;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n\n    .confirm {\n        padding: 10px 0;\n        text-align: center;\n        width: 40%;\n        background-color: #E14C46;\n        color: #fff;\n        border-radius: 8px;\n    }\n\n    .cancel {\n        padding: 10px 0;\n        text-align: center;\n        width: 40%;\n        border: solid 1px #ddd;\n        border-radius: 8px;\n    }\n\n\n}\n\n.adm-popup-body {\n    background-color: #fff;\n}\n\n.popup-list-loading {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    background: transparent;\n    position: fixed;\n    top: 45px;\n    bottom: 84px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
